import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], 
  loading: false,
  error: null,
};

const gstr3BReportSlice = createSlice({
  name: "Gstr3BReport",
  initialState,
  reducers: {
    Gstr3BReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    Gstr3BReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload; 
    },
    Gstr3BReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  Gstr3BReportRequest,
  Gstr3BReportSuccess,
  Gstr3BReportFailure,
} = gstr3BReportSlice.actions;

export default gstr3BReportSlice.reducer;
